export const MODAL_STRINGS = {
    HeadOverToAccountsPage:
        'Trying to change this appointment or book another? ' +
        'Head over to your my accounts page.',
    MyAccounts: 'My Accounts',
    NeverMind: 'Never Mind',
    Ok: 'Ok',
    OopsAppointmentAlreadySubmitted:
        'Oops! This appointment has already been submitted.',
    OopsAppointmentNoLongerAvailable:
        'Oops! The appointment you selected is no longer available.',
    OopsItLooksLikeYouSteppedAway:
        'Oops! It looks like you stepped away for a while.',
    OopsSomethingWentWrong: 'Oops! Something went wrong.',
    OopsWereUnableToBook:
        "Oops! We're unable to book appointments with this practice right now.",
    PleaseSelectANewTime: 'Please select a new time.',
    Refresh: 'Refresh',
    SelectANewTime: 'Select a new time',
    WeClearedYourInformation:
        'We cleared your information to protect your privacy. ' +
        'Please re-enter it now to finish booking your appointment.',
    GoToHomePage: 'Go to home page',
    Sorry: 'Sorry!',
    YouveReachedMaximumAppointments1:
        "You've reached the maximum number of appointments you can schedule at this time.",
    YouveReachedMaximumAppointments2:
        "You'll be able to book again after your next appointment.",
    YouveReachedMaximumAppointments3:
        'Questions? Give us a call at (855) 962-3621.',
    MaximumVaccineAppointmentHeaderDose1:
        'There’s an existing COVID-19 vaccine dose 1 appointment for this patient.',
    MaximumVaccineAppointmentHeaderDose2:
        'There’s an existing COVID-19 vaccine dose 2 appointment for this patient.',
    MaximumVaccineAppointmentBody:
        'Due to limited vaccine supply, you can only book one vaccine appointment per patient at this time.',
    ViewMyUpcomingAppointments: 'View upcoming appointments',
    Close: 'Close',
    PatientTimesOverlap:
        'You already have an appointment scheduled at this time. Please choose another time to continue.',
    PhoneIsVerifiedFailure: 'Please verify your phone number to continue.',
};
